<template>
  <div>
    <!-- 个人信息修改 -->
    <MTop title="个人信息修改" />
    <!-- 表单 -->
    <div style="margin-top:20px;" class=" bgc-white mob-per">
      <el-form label-position="left" :model="formInfoData" :rules="rules" label-width="82px">
        <el-form-item label="角色：">
          <span>{{formInfoData.roleName}}</span>
        </el-form-item>
        <el-form-item label="手机：">
          <el-input style="border:none;" v-model="formInfoData.mobile"></el-input>
          <!-- <span class="ml"> -->
            <!-- <router-link to="/changephone">修改/添加手机号</router-link> -->
            <!-- <el-button v-if="isMobile" @click="isMobile = !isMobile" type="text">添加/修改手机号</el-button> -->
          <!-- </span> -->
        </el-form-item>
        <el-form-item label="邮箱：">
          <span>{{formInfoData.email}}</span>
          <span class="ml">
            <!-- <router-link to="/editemail">修改邮箱</router-link> -->
          </span>
        </el-form-item>
        <el-form-item label="昵称：">
          <el-input v-model="formInfoData.username"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名：">
          <el-input v-model="formInfoData.truename"></el-input>
        </el-form-item>
        <!-- <el-form-item label="登录密码：">
        <el-input type="password" v-model="formInfoData.password" clearable></el-input>
        <div class="f12" style="color:red;">注：如不修改密码请留空</div>
        </el-form-item>-->
        <el-form-item label="性别：">
          <el-radio-group size="mini" v-model="isRadio" @change="selectRadio">
            <el-radio-button label="男"></el-radio-button>
            <el-radio-button label="女"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="职务：">
          <el-input v-model="formInfoData.position"></el-input>
        </el-form-item>
        <el-form-item label="简介：">
          <el-input v-model="formInfoData.intro" type="textarea" :rows="5"></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-button style="width:100%;" @click="saveInfos" type="primary">保存</el-button>
        </el-form-item> -->
      </el-form>
      <div style="width:100%;padding:20px;">
          <el-button style="width:100%;" @click="saveInfos" type="primary">保存</el-button>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      isMobile: true,
      formInfoData: {},
      isRadio: "男",
      rules: {
        truename: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        code: [{ required: true, message: "请输入邮箱验证码", trigger: "blur" }]
      }
    };
  },
  methods:{
      // 获取个人信息
    getUserInfos: async function() {
      var res = await this.$http.get(`/v1/userInfo/getUserInfo`);
      var { code, data, message } = res.data;
      if (code == 0) {
        this.formInfoData = data;
        this.$store.state.userInfo = data;
        console.log(this.formInfoData);
        this.isRadio = data.sex == "F" ? "女" : "男";
      } else if (code == 40100) {
        this.$message.error(message);
        this.$router.push("/login");
      } else {
        this.$message.error(message);
      }
    },
    // 选择性别
    selectRadio: function() {
      this.formInfoData.sex = this.isRadio == "女" ? "F" : "M";
      console.log(this.isRadio);
    },
    // 保存信息
    saveInfos: async function() {
      var res = await this.$http.post(
        "/v1/busUser/saveOrUpdateUser",
        this.formInfoData
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$message.success("修改个人资料成功。");
      } else {
        this.$message.error(message);
      }
    }
  },
  mounted:function(){
       this.getUserInfos();
  }
};
</script>

<style scoped lang="scss">
.mob-per{
  padding: 0px 10px;
    .el-form-item{
        border-bottom: 1px solid #ddd;
        padding: 5px 10px;
        margin-bottom: 0px;
    }
}
</style>
<style>
 .mob-per .el-input__inner{
     border:none;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile/personinfo/editperson.vue